/**
 * Paginação das tabelas.
 *
 * Mostra "Mostrando 16–30 de 120 arquivos", os números com reticências quando
 * há muitas páginas, e um seletor de itens por página. Em telas estreitas os
 * números e o seletor somem, restando Anterior/Próxima — o que cabe sem
 * espremer.
 */

/**
 * Janela de páginas com reticências. Sempre mostra a primeira, a última e as
 * vizinhas da atual, sem nunca ultrapassar 7 posições.
 *   1 … 4 [5] 6 … 20
 */
function janela(pagina, totalPaginas) {
  if (totalPaginas <= 7) {
    return Array.from({ length: totalPaginas }, (_, i) => i + 1);
  }

  const paginas = new Set([1, totalPaginas, pagina]);
  if (pagina > 1) paginas.add(pagina - 1);
  if (pagina < totalPaginas) paginas.add(pagina + 1);

  // Mantém largura estável nas pontas, para os botões não "pularem".
  if (pagina <= 3) [2, 3, 4].forEach((n) => paginas.add(n));
  if (pagina >= totalPaginas - 2) {
    [totalPaginas - 1, totalPaginas - 2, totalPaginas - 3].forEach((n) => paginas.add(n));
  }

  const ordenadas = [...paginas].filter((n) => n >= 1 && n <= totalPaginas).sort((a, b) => a - b);

  const comReticencias = [];
  let anterior = 0;
  for (const n of ordenadas) {
    if (anterior && n - anterior > 1) comReticencias.push('…');
    comReticencias.push(n);
    anterior = n;
  }
  return comReticencias;
}

export function Paginacao({
  pagina,
  totalPaginas,
  total,
  de,
  ate,
  tamanho,
  irPara,
  alterarTamanho,
  rotulo = 'registros',
  tamanhos = [15, 30, 50, 100],
}) {
  // Uma página só e poucos itens: a barra não acrescenta nada.
  if (total === 0) return null;
  if (totalPaginas === 1 && total <= (tamanhos[0] || 15)) {
    return (
      <div className="ff-paginacao">
        <span className="ff-paginacao__info">
          <strong>{total}</strong> {rotulo}
        </span>
      </div>
    );
  }

  const paginas = janela(pagina, totalPaginas);

  return (
    <nav className="ff-paginacao" aria-label="Paginação">
      <span className="ff-paginacao__info">
        Mostrando <strong>{de}</strong>–<strong>{ate}</strong> de <strong>{total}</strong> {rotulo}
      </span>

      <div className="ff-paginacao__controles">
        {alterarTamanho && (
          <select
            className="ff-pag-tamanho"
            value={tamanho}
            onChange={(e) => alterarTamanho(Number(e.target.value))}
            aria-label="Itens por página"
          >
            {tamanhos.map((n) => (
              <option key={n} value={n}>
                {n} por página
              </option>
            ))}
          </select>
        )}

        <button
          type="button"
          className="ff-pag-btn"
          onClick={() => irPara(pagina - 1)}
          disabled={pagina <= 1}
        >
          <i className="bi bi-chevron-left" aria-hidden="true" />
          <span className="ff-pag-numero">Anterior</span>
        </button>

        {paginas.map((n, i) =>
          n === '…' ? (
            <span key={`r${i}`} className="ff-pag-reticencias ff-pag-numero" aria-hidden="true">
              …
            </span>
          ) : (
            <button
              key={n}
              type="button"
              className={`ff-pag-btn ff-pag-numero${n === pagina ? ' ativo' : ''}`}
              onClick={() => irPara(n)}
              aria-current={n === pagina ? 'page' : undefined}
              aria-label={`Página ${n}`}
            >
              {n}
            </button>
          )
        )}

        <button
          type="button"
          className="ff-pag-btn"
          onClick={() => irPara(pagina + 1)}
          disabled={pagina >= totalPaginas}
        >
          <span className="ff-pag-numero">Próxima</span>
          <i className="bi bi-chevron-right" aria-hidden="true" />
        </button>
      </div>
    </nav>
  );
}

export default Paginacao;
